import { render, staticRenderFns } from "./CkCalendarHeader.vue?vue&type=template&id=18496d36"
import script from "./CkCalendarHeader.vue?vue&type=script&lang=js"
export * from "./CkCalendarHeader.vue?vue&type=script&lang=js"
import style0 from "./CkCalendarHeader.vue?vue&type=style&index=0&id=18496d36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports